export const API_REGISTER="/gateway/app/register"
